import { FullScreenService } from './fullscreen.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
@NgModule({
    imports: [CommonModule],
    providers: [FullScreenService]
})
export class FullScreenModule {}
